import { prod } from "application/constants/app-constants";
import { length, split } from "ramda";

export default function getToken() {
  let token = "45b3aefa-5d29-404e-a235-442135baa073";
  if (prod) {
    const pathnames = split("/", window.location.pathname);
    token = pathnames[length(pathnames) - 2];
  }
  return token;
}
